import { render, staticRenderFns } from "./declaration-page.vue?vue&type=template&id=22135dd5"
import script from "./declaration-page.vue?vue&type=script&lang=js"
export * from "./declaration-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports